import { useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Sidebar, { DRAWER_WIDTH } from './Sidebar';
import Header from './Header';
import ImpersonationBanner, { BANNER_HEIGHT } from './ImpersonationBanner';
import { useAuth } from '../context/AuthContext';

/**
 * Layout principal del sistema.
 *  - Desktop (>= md): Sidebar fijo a la izquierda + Header arriba + contenido
 *  - Mobile (< md): Sidebar como drawer overlay (cerrado por defecto), Header con boton hamburguesa
 *  - Banner de impersonacion (cuando aplica) ocupa la parte superior
 */
export default function MainLayout() {
  const { impersonatingEmpresaId } = useAuth();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [mobileOpen, setMobileOpen] = useState(false);
  const topOffset = impersonatingEmpresaId ? BANNER_HEIGHT : 0;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <ImpersonationBanner />

      <Sidebar
        topOffset={topOffset}
        mobileOpen={mobileOpen}
        onCloseMobile={() => setMobileOpen(false)}
      />

      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          // En desktop el sidebar ocupa DRAWER_WIDTH y el contenido toma el resto.
          // En mobile, el sidebar es overlay → el contenido ocupa 100%.
          width: isMobile ? '100%' : `calc(100% - ${DRAWER_WIDTH}px)`,
          minWidth: 0, // evita overflow horizontal en mobile
        }}
      >
        <Header topOffset={topOffset} onMenuClick={() => setMobileOpen(true)} />
        <Box
          component="main"
          sx={{
            p: { xs: 2, md: 3 },
            flexGrow: 1,
            bgcolor: 'background.default',
            overflowX: 'auto', // contenido ancho (tablas) usa scroll
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
